"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ruby = _interopRequireDefault(require("highlight.js/lib/languages/ruby"));

var _default = _ruby.default;
exports.default = _default;